import gsap from "gsap";
import { _backgroundGradient } from "../utils/_backgroundGradient";
import { _inview } from "../utils/_inview";
import { _lazyLoad } from "../utils/_lazyLoad";
import { _splitText } from "../utils/_splitText";
import MainClass, { MAIN_CLASS_PARAMS } from "../utils/mainClass";

class MastheadCaseStudy extends MainClass {
    el: {
        desc: HTMLElement | null;
        banner: HTMLElement | null;
    };

    background: _backgroundGradient | null;

    constructor(props: MAIN_CLASS_PARAMS) {
        super(props);

        this.el = {
            desc: this.selector.querySelector(".js-masthead-case-study-desc"),
            banner: this.selector.querySelector(".js-masthead-case-study-banner"),
        };

        this.background = null;

        this.init();
    }

    init() {
        // for lazyload
        _lazyLoad();

        // for bg
        const _colors = this.selector.dataset.colors?.split(",") || [];
        this.background = new _backgroundGradient({
            target: this.selector,
            uniforms: {
                color1: _colors[0] || null,
                color2: _colors[1] || null,
                color3: _colors[2] || null,
                color4: _colors[3] || null,
                color5: _colors[4] || null,
            },
        });

        // for inview animate
        const _descItems = [] as HTMLElement[];

        this.selector.querySelectorAll(".js-masthead-case-study-desc-item").forEach((item) => {
            Array.from(item.children).forEach((item) => {
                _descItems.push(item as HTMLElement);
            });
        });

        const _staggerElements = [];
        const _class = "js-masthead-case-study-desc-item";
        _descItems.forEach((item) => {
            const _item = item;
            const _parent = _item.parentNode as HTMLElement;

            if (_parent?.classList.contains(_class)) _parent?.classList.remove(_class);

            if (_item.classList.contains("js-masthead-case-study-desc-title")) {
                new _splitText({ target: _item });

                _item.querySelectorAll(".word").forEach((item) => {
                    item.classList.add(_class);
                });
            } else {
                _item.classList.add(_class);
                _staggerElements.push(_item);
            }
        });

        this.selector.classList.remove("opacity-0");

        new _inview({
            target: this.selector,
            callback: (instance: _inview) => {
                this.el.desc?.classList.remove("opacity-0");
                this.el.banner?.classList.remove("opacity-0");

                gsap.fromTo(
                    this.el.banner,
                    { opacity: 0, x: window.innerWidth < 601 ? 0 : 40, y: window.innerWidth < 601 ? 40 : 0 },
                    { duration: 0.8, opacity: 1, x: 0, y: 0 },
                );

                const _items = this.selector.querySelectorAll(`.${_class}`);
                gsap.fromTo(
                    _items,
                    {
                        opacity: (index: number, target: HTMLElement) => {
                            if (target.classList.contains("word")) return 1;
                            return 0;
                        },
                        y: (index: number, target: HTMLElement) => {
                            if (target.classList.contains("word")) return target.parentNode.offsetHeight;
                            return 20;
                        },
                    },
                    {
                        opacity: 1,
                        y: 0,
                        duration: 0.5,
                        stagger: 0.05,
                        delay: 0.5,
                        onComplete: () => {
                            gsap.set(_items, { clearProps: "opacity,transform" });
                        },
                    },
                );
            },
        });

        // console.log("MastheadCaseStudy", this);
    }
}

export default MastheadCaseStudy;
